<script lang="ts" setup>
import { useI18n } from '@/plugins/i18n'
//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

const props = defineProps({
    searchContext : { type: String, default: '', required: false },
    item: { type: Object, default: () => ({}), required: true },
    docOffset: { type: Number,  default: 0, required: false }
});

const handleProductLinkClick = (docNo: string, docId: string) => {
    //@ts-ignore
    window.dataLayer = window.dataLayer || [];
    //@ts-ignore
    window.dataLayer.push({ 'event' : 'SearchEvent', 'eventCategory': 'Search', 'eventAction':  'StandardSearchResultDocClick', 'eventLabel': 'Standard Result Doc Click', 'docNo': docNo, docTitle: 'UNKNOWN', 'docId': docId, 'resultCount': 'UNKNOWN'});
}
</script>


<template>
    <div class="search-result-item">
        <div class="update-status">
            <div class="status-label">{{ t(item?.doc_update_status ?? '') }}</div>
            <div class="update-date">{{ item?.update_received_at ?? '' }}  </div>
        </div>
         <div class="update-details">
            <div class="update-details--doc-title result-title">
                <a  v-bind:href="'/management/display/index/'+ docOffset + '/' + item.doc_id + '/-/' + searchContext"
                @click="handleProductLinkClick(item.doc_name, item.doc_id)">
                {{ item.doc_name ?? '' }}
                </a>
            </div>
            <div class="update-details--doc-description">{{ item.doc_title_translated ?? '' }}</div>
            <div class="update-details--doc-updated-version">
                <div class="result-sub-title">{{ t('updatedVersion') }}</div>
                <div class="update-details--doc-version">{{ item.updated_version ?? '' }}</div>
            </div>
        </div>
        <div class="update-change-summary">
            <div class="result-sub-title">{{ t('changeSummary') }}</div>
            <div class="update-change-summary--desc" v-html="item.change_summary ?? ''"></div>
        </div>
    </div>
</template>
<style lang="scss">
    @use './updateItem.scss';
</style>